module.exports = __webpack_public_path__ + "images/newerp_button1.1788921444950.png";